var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3166 3.39289C10.054 0.86743 6.27325 0.0869528 3.43839 2.39952C0.603515 4.71209 0.204404 8.57855 2.43065 11.3137C4.28162 13.5876 9.88329 18.3838 11.7192 19.9362C11.9246 20.1098 12.0273 20.1967 12.1471 20.2307C12.2516 20.2605 12.366 20.2605 12.4707 20.2307C12.5905 20.1967 12.6931 20.1098 12.8985 19.9362C14.7345 18.3838 20.3361 13.5876 22.1871 11.3137C24.4133 8.57855 24.0629 4.68776 21.1793 2.39952C18.2957 0.11128 14.5792 0.86743 12.3166 3.39289Z",
    stroke: "#00CC99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.405531ef85b6d17c2bec0c85d7eae1bf.svg";
export { ForwardRef as ReactComponent };